import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Portfolio from "@/pages/Portfolio";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import DeliveryPage from "@/pages/DeliveryPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminHome from "@/pages/admin/AdminHome";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import PostEditor from "@/pages/admin/PostEditor";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminLogos from "@/pages/admin/AdminLogos";
import AdminReels from "@/pages/admin/AdminReels";
import AdminDeliveries from "@/pages/admin/AdminDeliveries";
import AdminDeliveryEditor from "@/pages/admin/AdminDeliveryEditor";
import ProtectedRoute from "@/components/ProtectedRoute";

const P = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/arbeit" element={<Portfolio />} />
            <Route path="/services" element={<Portfolio />} />
            <Route path="/leistungen" element={<Portfolio />} />
            <Route path="/kundenstimmen" element={<Portfolio />} />
            <Route path="/ueber-mich" element={<Portfolio />} />
            <Route path="/kontakt" element={<Portfolio />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/drop/:slug" element={<DeliveryPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<P><AdminHome /></P>} />
            <Route path="/admin/posts" element={<P><AdminDashboard /></P>} />
            <Route path="/admin/new" element={<P><PostEditor /></P>} />
            <Route path="/admin/edit/:id" element={<P><PostEditor /></P>} />
            <Route path="/admin/testimonials" element={<P><AdminTestimonials /></P>} />
            <Route path="/admin/logos" element={<P><AdminLogos /></P>} />
            <Route path="/admin/reels" element={<P><AdminReels /></P>} />
            <Route path="/admin/deliveries" element={<P><AdminDeliveries /></P>} />
            <Route path="/admin/deliveries/new" element={<P><AdminDeliveryEditor /></P>} />
            <Route path="/admin/deliveries/edit/:id" element={<P><AdminDeliveryEditor /></P>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
